import axios from "../axios/axios";
import { MarketplaceResponse } from "../types/shared";
import {
  CnCOrderResponse,
  CnCTransactionResponse,
} from "../types/api";

export const getUserInstitutions = async (
  userId: number
): Promise<MarketplaceResponse[]> => {
  const res = await axios.get<MarketplaceResponse[]>(
    `/user_marketplace/user_marketplaces/user_id/${userId}`
  );
  return res.data;
};

export const getUserOrders = async (
  userId: number
): Promise<CnCOrderResponse[]> => {
  const res = await axios.get<CnCOrderResponse[]>(
    `/click_and_collect_order/user_marketplace/user_id/${userId}`
  );
  return res.data;
};

export const getUserTransactions = async (
  userId: number
): Promise<CnCTransactionResponse[]> => {
  const res = await axios.get<CnCTransactionResponse[]>(
    `/click_and_collect_transaction/user_marketplace/user_id/${userId}`
  );
  return res.data;
};
